import { useEffect, useState } from "react";
import { ConfigProvider, DatePicker } from "antd";
import locale from "antd/lib/locale/ko_KR";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import * as Common from "../commons/common";
import * as Types from "../commons/typeDTO";
import * as TypeUtils from "../commons/typeUtils";
import * as Request from "../commons/request";

import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

dayjs.locale("ko");

function CustomDatePicker({
    value,
    placeholder,
    allowClear,
    format,
    picker,
    onChange,
}: {
    value?: dayjs.Dayjs | undefined;
    placeholder?: string;
    allowClear?: boolean;
    format?: string;
    picker?: "time" | "date" | "week" | "month" | "quarter" | "year";
    onChange?: (value: dayjs.Dayjs | null) => void;
}) {
    const [holidays, setHolidays] = useState<Array<TypeUtils.Holidays>>([]);

    useEffect(() => {
        requestGetHolidays(dayjs().year());
    }, []);

    // holidays
    const requestAxiosGetHolidays = async (year: string, month?: string) => {
        const response = await utilAxiosWithAuth().get(Request.RENT_HOLIDAYS_URL, { params: { year: year, month: month } });
        return response.data;
    };

    const {
        loading: loadingGetHolidays,
        error: errorGetHolidays,
        data: resultGetHolidays,
        execute: requestGetHolidays,
    } = useAsyncAxios(requestAxiosGetHolidays);

    useEffect(() => {
        if (resultGetHolidays === null) return;

        console.log("resultGetHolidays", resultGetHolidays);
        setHolidays(resultGetHolidays.holidays);
    }, [resultGetHolidays]);

    useEffect(() => {
        if (errorGetHolidays === null) return;

        console.log("errorGetHolidays", errorGetHolidays);
    }, [errorGetHolidays]);

    return (
        <ConfigProvider locale={locale}>
            <DatePicker
                value={value}
                placeholder={placeholder}
                allowClear={allowClear ?? true}
                format={format}
                picker={picker ?? "date"}
                onChange={onChange}
                onPanelChange={(value, mode) => {
                    if (holidays.length === 0 || +holidays[0].date.substring(0, 4) !== value?.year()) {
                        requestGetHolidays(value?.year());
                    }
                }}
                cellRender={(current: any, info: any) => {
                    if (info.type !== "date") return info.originNode;

                    const date = current.format(Common.FORMAT_DATE);
                    const holiday = holidays?.find((item) => item.date === date);
                    return (
                        <div className={`ant-picker-cell-inner ant-picker-cell-week-${current.day()} ${holiday ? "ant-picker-cell-holiday" : ""}`}>
                            {current.date()}
                        </div>
                    );
                }}
            />
        </ConfigProvider>
    );
}

export default CustomDatePicker;
